import { injectGlobal } from 'styled-components'
import fontFiles from './gilroy'

const globalStyles = injectGlobal`
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Extrabold"), 
            local("Gilroy-Extrabold"),
            url(${fontFiles.GilroyExtraboldWOFF2}) format('woff2'),
            url(${fontFiles.GilroyExtraboldWOFF}) format('woff');
        font-weight: 800;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Thin"), 
            local("Gilroy-Thin"),
            url(${fontFiles.GilroyThinWOFF2}) format('woff2'),
            url(${fontFiles.GilroyThinWOFF}) format('woff');
        font-weight: 100;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Bold"), 
            local("Gilroy-Bold"),
            url(${fontFiles.GilroyBoldWOFF2}) format('woff2'),
            url(${fontFiles.GilroyBoldWOFF}) format('woff');
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Black"), 
            local("Gilroy-Black"),
            url(${fontFiles.GilroyBlackWOFF2}) format('woff2'),
            url(${fontFiles.GilroyBlackWOFF}) format('woff');
        font-weight: 900;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Light"), 
            local("Gilroy-Light"),
            url(${fontFiles.GilroyLightWOFF2}) format('woff2'),
            url(${fontFiles.GilroyLightWOFF}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Medium"), 
            local("Gilroy-Medium"),
            url(${fontFiles.GilroyMediumWOFF2}) format('woff2'),
            url(${fontFiles.GilroyMediumWOFF}) format('woff');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'Gilroy';
        src: local("Gilroy Heavy"), 
            local("Gilroy-Heavy"),
            url(${fontFiles.GilroyHeavyWOFF2}) format('woff2'),
            url(${fontFiles.GilroyHeavyWOFF}) format('woff');
        font-weight: 900;
        font-style: normal;
    }
`

export default globalStyles